/**
 * Portal Types actions.
 * @module actions/portalTypes/portalTypes
 */

import { GET_PORTAL_TYPES } from '../../constants/ActionTypes';

/**
 * Get portal types.
 * @function getPortalTypes
 * @returns {Object} Get portal types action.
 */
export function getPortalTypes() {
  return {
    type: GET_PORTAL_TYPES,
    request: {
      op: 'get',
      path: '/@portal-types',
    },
  };
}
